import axios from 'axios';

axios.defaults.baseURL = '/api-news';

// 反馈
export function toFeedBack(data) {
    return axios.post('/feedBack/add', {...data}).then(res => {
        return res
    }).catch(err => {
        return Promise.reject(err)
    })
  }

// 新增新闻
export function addNews(data) {
  return axios.post('/news/add', {...data}).then(res => {
    return res
}).catch(err => {
    return Promise.reject(err)
})
}

// 更新新闻
export function updateNews(data) {
  return axios.post('/news/update', {...data}).then(res => {
    return res
}).catch(err => {
    return Promise.reject(err)
})
}

// 获取新闻列表
export function getNewsList(pageSize,pageNum) {
return axios.post('/news/getNewsList', {pageSize:pageSize,pageNum:pageNum}).then(res => {
  return res
}).catch(err => {
  return Promise.reject(err)
})
}

// 删除新闻
export function deleteNews(id) {
  const url = `/news/delete/${id}`;
  return axios.get(url);
}



// 获取新闻详情
export function getNewsDetail(id) {
    const url = `/news/getNews/${id}`;
    return axios.get(url);
}

// 新增新闻
export function uploadImg(data) {
  const formData = new window.FormData();
  formData.append("multipartFile", data);
  return axios.post('/news/upload', formData).then(res => {
    return res
}).catch(err => {
    return Promise.reject(err)
})
}
